import { render, staticRenderFns } from "./PeriodicStats.vue?vue&type=template&id=173c11cb&scoped=true&"
import script from "./PeriodicStats.vue?vue&type=script&lang=js&"
export * from "./PeriodicStats.vue?vue&type=script&lang=js&"
import style0 from "./PeriodicStats.vue?vue&type=style&index=0&id=173c11cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173c11cb",
  null
  
)

export default component.exports